<template>
  <!-- User Applications Start Here -->
  <div v-if="jobApplications" class="user-applications-list-container">

    <!-- Heading Starts Here -->
    <div class="applications-heading-container">
      <div class="heading">{{ jobHeading }}</div>
    </div>
    <!-- Heading ends Here -->

    <!-- Jobs user applications item container starts here -->
    <div
      v-if="jobApplications.length > 0"
      class="applications-list"
    >
      <div
        v-for="(application, index) in jobApplications"
        v-bind:key="index"
        class="application-item"
        @click="$emit('viewApplication', application.id)"
      >
        <div class="job-name">{{jobName}}</div>
        <div v-if="jobLocation" class="job-location">{{jobLocation}}</div>
        <div class="applicant-fullname" v-if="application.applicantInfo">
          Name:
          <span>{{application.applicantInfo.firstName}} {{application.applicantInfo.lastName}}</span>
        </div>
        <div class="job-status">Status:
          <span
            v-bind:class="{
              'status-in-review':application.status === 'in-review',
              'status-shortlisted':application.status === 'shortlisted',
              'status-invited':application.status === 'scheduled-for-interview',
              'status-hired':application.status === 'hired',
              'status-declined':application.status === 'declined',
            }"
          >
            {{application.status}}
          </span>
        </div>
        <div class="application-date" v-if="application.createdAt">
          Applied on:
          <span>{{new Date(application.createdAt).toDateString()}}</span>
        </div>
      </div>
    </div>
    <!-- Jobs user applications item container ends here -->
    <div v-else>
      <EmptyDashboardState
        v-bind:emptyHeading="emptyApplication"
        v-bind:desc="appDesc"
      />
    </div>
  </div>
  <!-- User Applications ends Here -->
</template>

<script>
import EmptyDashboardState from '../EmptyDashboardState';
export default {
  name: 'UserApplications',
  components: { EmptyDashboardState },
  props:[
    'jobHeading',
    'jobApplications',
    'jobName',
    'jobLocation'
  ],
  data() {
    return{
      emptyApplication:'',
      appDesc:'No Applications Found',
    };
  }
};
</script>

<style scoped>
  .user-applications-list-container {
    background: white;
    border-radius: 15px;
    width: 100%;
    overflow-y: scroll;
    min-width: 300px;
    max-height: 1200px; /* Previous 'max-height' Value: 950px - Ensures scroll behavior of the application's component */
    /* height: auto; */
    display: grid;
    grid-template-rows: 80px auto;
  }
  .user-applications-list-container .applications-heading-container {
    border-radius:15px 15px 0 0;
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:0 2.75rem;
    background: rgba(27, 36, 72, 0.04);
  }

  .applications-heading-container .heading {
    font-size:1.25rem;
    color:#707070;
    font-weight:600;
    line-height:1.524rem;
  }

  /* .user-applications-list-container .applications-list {
    overflow-y: scroll;
  } */

  .applications-list .application-item {
    text-transform: capitalize;
    display:flex;
    flex-direction:column;
    padding:1rem 1.75rem;
    border-bottom: 0.5px solid rgba(196, 196, 196, 0.5);
    /* box-shadow: 0px 0px 4px 2px rgb(180 180 180 / 15%); */
    cursor: pointer;
    box-sizing: border-box;
  }

  .applications-list .application-item:hover {
    background: rgba(2, 95, 160, 0.15);
  }

  /* .application-item:nth-child(2),
  .application-item:nth-child(5) {
    border-left: 1px solid rgba(196, 196, 196, 0.5);
    border-right: 1px solid rgba(196, 196, 196, 0.5);
  } */

  .application-item:last-child {
    border-radius:0 0 15px 15px;
  }

  .application-item:first-child {
    border-radius:0;
  }

  .application-item .job-name {
    font-size: 0.875rem;
    margin-bottom: 12px;
    font-weight: 700;
    color: var(--black);
    line-height: 1.8rem;
    text-transform: capitalize;
  }

  .application-item .job-location {
    font-weight: 500;
    margin-bottom:10px;
    color: #828282;
    line-height: 1.371rem;
    font-size:0.8rem;
  }

  .application-item .applicant-fullname, .application-item .job-status,
  .application-item .job-location, .application-item .application-date {
    margin-bottom: 3.5px;
  }

  .application-item .applicant-fullname,
  .application-item .job-status,
  .application-item .application-date {
    color:#828282;
    font-weight:600;
    font-size:0.8rem;
    line-height: 1.6rem;
  }

  .applicant-fullname span {
    color:#252525;
    font-weight: 800;
  }

  .status-in-review {
    color:#767676;
  }

  .status-shortlisted {
    color:#FFB300;
  }

  .status-invited {
    color:var(--colorSecondary);
  }

  .status-hired {
    color:#27AE60;
  }

  .status-declined{
    color:#DF2029;
  }

  .application-item span {
    margin-left: 0.55rem;
  }

  @media only screen and (max-width: 1200px) {
    .user-applications-list-container .applications-heading-container {
      padding: 0 1.75rem;
    }

    .applications-list .application-item {
      padding: 1rem 1.75rem;
    }

    .application-item .job-name {
      font-size:calc(1.375rem/1.2);
    }

    .application-item .job-location {
      font-size:calc(1.125rem/1.2);
      margin-bottom:calc(7px / 1.2);
    }

    .application-item .applicant-fullname,
    .application-item .job-status,
    .application-item .application-date {
      font-size:calc(1.25rem/1.5);
    }
  }

  @media only screen and (max-width: 767px) {
    .dashboard-jobs-list-container .applications-list {
      display:grid;
      grid-template-columns: 1fr 1fr ;
      grid-template-rows: auto;
    }

    .application-item:nth-child(3) {
      border-right: 1px solid rgba(196, 196, 196, 0.5);
    }
  }

  @media only screen and (max-width: 565px) {
    .user-applications-list-container {
      min-width: unset;
    }
  }

  @media only screen and (max-width: 420px) {

  }

</style>
